import { defineStore } from 'pinia';

export default defineStore('navbarButton Store', {
  state: () => ({
    filterMenuSwitch: false, // 篩選側欄
    myComponentSearchLabel: "搜尋我的元件", // 私有元件搜尋框 label
  })
})